import CustomerList from '../../components/Customers/CustomerList';
import CustomerDetailPanel from '../../components/Customers/CustomerDetailPanel';
import { useCustomersList } from '../../components/Customers/hooks/useCustomersList';
import s from './CustomersPage.module.css';

function CustomersPage() {
  const list = useCustomersList();

  return (
    <div className={s.page} data-content-width="wide">
      <CustomerList
        rows={list.rows}
        isLoading={list.isLoading}
        isFetching={list.isFetching}
        search={list.search}
        onSearchChange={list.setSearch}
        hasDebt={list.hasDebt}
        onToggleHasDebt={list.toggleHasDebt}
        hasActiveSubscription={list.hasActiveSubscription}
        onToggleHasActiveSubscription={list.toggleHasActiveSubscription}
        testUser={list.testUser}
        onToggleTestUser={list.toggleTestUser}
        brandCode={list.brandCode}
        onBrandCodeChange={list.setBrandCode}
        fromDate={list.fromDate}
        toDate={list.toDate}
        onDateRangeChange={list.setDateRange}
        selectedId={list.selected?.id ?? null}
        onSelect={list.selectCustomer}
        hasNextPage={list.hasNextPage}
        isFetchingNextPage={list.isFetchingNextPage}
        onLoadMore={() => list.fetchNextPage()}
      />
      <CustomerDetailPanel customer={list.selected} />
    </div>
  );
}

export default CustomersPage;
